export const tableElementTagName = 'atomic-table-element';
